import { OptionProperty } from '../enums';

// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_NO_VALUE_OPTION = {
  [OptionProperty.Label]: 'No Available Options',
  [OptionProperty.Disabled]: true,
};
